(function(){
  'use strict';
  document.documentElement.classList.add('js');
  var mobileDensity=window.matchMedia('(max-width:767px)');
  function syncDensity(){
    document.querySelectorAll('.store-collection-page').forEach(function(scope){
      var grid=scope.querySelector('[data-wc-catalog-grid]');
      if(!grid){return;}
      var requested=grid.dataset.requestedDensity||grid.dataset.density||'three';
      grid.dataset.requestedDensity=requested;
      var actual=mobileDensity.matches&&requested==='three'?'two':requested;
      grid.dataset.density=actual;
      scope.querySelectorAll('[data-wc-density]').forEach(function(button){
        button.hidden=mobileDensity.matches&&button.dataset.wcDensity==='three';
        button.setAttribute('aria-pressed',String(button.dataset.wcDensity===actual));
      });
    });
  }
  syncDensity();
  mobileDensity.addEventListener('change',syncDensity);
  document.addEventListener('shopify:section:load',syncDensity);
  document.addEventListener('change',function(event){
    var select=event.target.closest('[data-wc-perpage] select');
    if(select){
      var target=new URL(window.location.href);
      target.searchParams.set('view',select.value);
      target.searchParams.delete('page');
      window.location.assign(target.toString());
    }
  });
  document.addEventListener('click',function(event){
    var density=event.target.closest('[data-wc-density]');
    if(density){
      var scope=density.closest('.store-collection-page');
      var grid=scope&&scope.querySelector('[data-wc-catalog-grid]');
      if(!grid){return;}
      grid.dataset.requestedDensity=density.dataset.wcDensity;
      syncDensity();
    }
    var link=event.target.closest('[data-wc-load-more]');
    if(!link||!window.fetch||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey){return;}
    event.preventDefault();
    if(link.getAttribute('aria-busy')==='true'){return;}
    var scope=link.closest('.store-collection-page');
    var grid=scope&&scope.querySelector('[data-wc-catalog-grid]');
    if(!grid){window.location.assign(link.href);return;}
    var label=link.textContent;
    link.textContent=link.dataset.loadingLabel;
    link.setAttribute('aria-busy','true');
    var error=scope.querySelector('.wc-load-error');
    if(error){error.hidden=true;}
    fetch(link.href,{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){
      if(!response.ok){throw new Error('page');}return response.text();
    }).then(function(html){
      var parsed=new DOMParser().parseFromString(html,'text/html');
      var fresh=parsed.querySelector('[data-wc-catalog-grid]');
      if(!fresh||!fresh.children.length){throw new Error('products');}
      Array.from(fresh.children).forEach(function(card){grid.appendChild(card);});
      var progress=parsed.querySelector('[data-wc-progress] progress');
      var count=parsed.querySelector('[data-wc-visible-count]');
      if(count){scope.querySelector('[data-wc-visible-count]').textContent=count.textContent;}
      if(progress){scope.querySelector('[data-wc-progress] progress').value=progress.value;}
      var next=parsed.querySelector('[data-wc-load-more]');
      if(next){link.href=next.href;link.textContent=label;link.removeAttribute('aria-busy');}else{link.remove();}
      document.dispatchEvent(new CustomEvent('womens:catalog:updated',{detail:{root:grid}}));
    }).catch(function(){
      link.removeAttribute('data-wc-load-more');
      link.removeAttribute('aria-busy');
      link.textContent=label;
      if(error){error.hidden=false;}
    });
  });
})();
